export default "__VITE_ASSET__qulApdr4__"